export default "__VITE_ASSET__21a15e55__"